// extracted by mini-css-extract-plugin
export default {"statusBar":"styles_statusBar__hN1Lg","active":"styles_active__55bIM","closeButton":"styles_closeButton__TNtR7","buttonActive":"styles_buttonActive__yLyru"};